<div #gmap style="width:100%; height: 100%"></div>
